export enum ImageVariant {
  EXTRA_SMALL = 'xs',
  SMALL = 'sm',
  MEDIUM = 'md',
  LARGE = 'lg',
  ORIGINAL = 'public',
}
